import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import styles from './file_details_info.module.css'
import strings from '../../strings/strings.json'
import moment from 'moment-jalaali'
import Api from '../../../pages/api/api'
import { useRouter } from 'next/router'
import EmulatorModal from '../emulator_modal'
import fileDownload from 'js-file-download';

export default function FileDetailsInfo(props) {

    const router = useRouter()
    const [openEmulatorModal, setOpenEmulatorModal] = useState(false)

    const fileIconHandler = (icon, className) => {

        return (
            <img
                className={className}
                alt="appLogo"
                src={icon ? `data:image/png;base64, ${icon}`
                    :
                    '/assets/icons/android.png'
                }
            />
        )
    }

    const handler = (icon, title) => {
        if (title === strings.general_pcap) {
            downloadPcapHandler()
            return
        }
        switch (icon) {
            case 'cloud_app_download':
                return downloadfileHandler()
            case 'cloud_buy_download':
                return props.generalState.userInfo.full_vulns_show ? downloadPdfHandler() : props.buyPdfHandler()
            case 'cloud_free_download':
                return downloadPdfHandler()
            default:
                break;
        }
    }

    const buttonHandler = (title, color, text_color, icon) => {
        return (
            <div className={styles.btn_container}>
                <button style={{ backgroundColor: color }} className={styles.btn_style} onClick={() => handler(icon, title)}>
                    <img src={`/assets/icons/${icon}.svg`} alt="Icon" />
                    <div className={styles.text_container}>
                        <span className={styles.btn_text} style={{ color: text_color }}>{title}</span>
                    </div>
                </button>
            </div>
        )
    }

    const infoFormatter = (title, subTitle, title_className, sub_className) => {
        return (
            <div className={styles.info_container}>
                <div className={`secondry_color ${title_className}`}>
                    {title}
                </div>
                <div style={title === strings.fileDetail_packagename ? { cursor: "pointer", textDecoration: "underline" } : null} className={`primary_color ${sub_className}`} onClick={() => title === strings.fileDetail_packagename && packagenameOnclickHandler()}>
                    {subTitle}
                </div>
            </div>
        )
    }

    //downloadPcap
    const downloadPcapHandler = () => {
        if (props.data.file_avail) {
            Api.downloadPCAPFile(props.data.sha256)
                .then(result => {
                    if (result.status === 200) {
                        const url = window.URL.createObjectURL(new Blob([result.data]))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', `${props.data !== undefined && props.data.md5}.cap`)
                        document.body.appendChild(link)
                        link.click()
                    } else {
                        props.setSnack(true, "error", strings.general_fileNotExist)
                    }
                })
        } else {
            props.setSnack(true, "error", strings.general_fileNotExist)
        }
    }

    //download file
    const downloadfileHandler = () => {
        if (props.data.file_avail) {
            Api.downloadFile(props.data.sha256)
                .then(result => {
                    if (result.status === 200) {
                        fileDownload(result.data, `${props.data !== undefined && props.data.package_name}.apk`);
                    } else {
                        props.setSnack(true, "error", strings.general_fileNotExist)
                    }
                })
        } else {
            props.setSnack(true, "error", strings.general_fileNotExist)
        }
    }

    //download pdf 
    const downloadPdfHandler = () => {
        let processing = true
        Api.downloadPdf(props.data.sha256)
            .then(result => {
                if (!result.processing) {
                    processing = false
                    const url = window.URL.createObjectURL(new Blob([result]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', "ScanReport_MD5.pdf")
                    document.body.appendChild(link)
                    link.click()
                } else {
                    props.setSnack(true, "error", strings.fileDetail_waitForVulns)
                }
            }).catch(err => {
                if (err.message !== "Network Error" && processing)
                    props.setSnack(true, "error", strings.fileDetail_waitForVulns)
            })
    }

    const packagenameOnclickHandler = () => {
        router.push({
            pathname: "/search/[packagename]",
            query: {
                packagename: props.data.package_name
            }
        })
    }

    const openModalHandler = () => {
        if (props.generalState.userInfo)
            setOpenEmulatorModal(true)
        else
            props.setSnack(true, "warning", strings.fileDetails_firstRegister)
    }

    const reviewClickHandler = () => {
        setOpenEmulatorModal(false)
        setTimeout(() => {
            setOpenEmulatorModal(true)
        }, 1000);
    }

    const timeHandler = (time) => {
        return moment(time).format('HH:mm jYYYY-jMM-jDD').split(" ")
    }

    return (
        <div className="relative">
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                    <div className={styles.app_logo_section}>
                        <div className={`${styles.app_logo_container} flex justify-center items-center`}>
                            {
                                fileIconHandler(props.data !== undefined && props.data.file_icon, 'h-10')
                            }
                        </div>
                        <div className={styles.run_btn_container}>
                            <button className={styles.run_btn} onClick={() => openModalHandler()}>
                                <img src="/assets/icons/run_app.svg" alt="Icon" />
                                <span>{strings.general_runApp}</span>
                            </button>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={3}>
                    <div className={styles.info_formatter_container}>
                        <div className={styles.package_container}>
                            {infoFormatter(strings.general_appName, props.data !== undefined && props.data.program_name, null, `${styles.subTitle_style} englishIranSans`)}
                            {infoFormatter(strings.fileDetail_packagename, props.data !== undefined && props.data.package_name, null, `${styles.subTitle_style} englishIranSans`)}
                        </div>
                        <div className={styles.sha_container}>{infoFormatter(strings.general_sha256, props.data !== undefined && props.data.sha256, "englishIranSans", "englishIranSans")}</div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3} lg={4}>
                    <div className={styles.info_formatter_container}>
                        <div className={styles.time_container}>
                            {infoFormatter(strings.general_lastTimeReviewed, props.data !== undefined && timeHandler(props.data.updated_at)[0], null, null)}
                            <div className={styles.last_data_reviewed}>{infoFormatter(strings.general_lastDateReviewed, props.data !== undefined && timeHandler(props.data.updated_at)[1].replace(/-/g, '/'), null, null)}</div>
                        </div>
                        {infoFormatter(strings.general_md5, props.data !== undefined && props.data.md5, "englishIranSans", `${styles.subTitle_style} englishIranSans`)}
                    </div>
                </Grid>
                <div className={styles.sha_container_mobile}>{infoFormatter(strings.general_sha256, props.data !== undefined && props.data.sha256, "englishIranSans", `${styles.subTitle_style} englishIranSans`)}</div>
                <Grid item xs={12} sm={12} md={4} lg={3}>
                    <div className={`${styles.downloads_container} ${styles.info_formatter_container}`}>
                        {buttonHandler(strings.general_pdf_free, "#f1f3f9", "#07465d", "cloud_free_download")}
                        {buttonHandler(strings.general_pdf_buy, "rgba(252, 173, 83, 0.2)", "#fcad53", "cloud_buy_download")}
                        {buttonHandler(strings.general_pcap, "#f1f3f9", "#07465d", "cloud_free_download")}
                        <div className={styles.downloadd_app_container}>{buttonHandler(strings.general_downloadApp, "#e3f5f1", "#41b9a2", "cloud_app_download")}</div>
                    </div>
                </Grid>
            </Grid>
            <div className={`${styles.rescan_container} absolute w-full flex justify-center z-10`}>
                <button className={`${styles.rescan} flex cursor-pointer py-2 lg:px-5 md:px-5 sm:px-5 xs:px-6 xs:ml-3`} onClick={() => props.doRescan()}>
                    <img className={styles.rescan_img} src="/assets/icons/rescan.svg" alt="Icons" />
                    <span>{strings.fileDetail_rescan}</span>
                </button>
            </div>
            {openEmulatorModal && <EmulatorModal data={props.data} reviewClicked={() => reviewClickHandler()} open={openEmulatorModal} close={() => setOpenEmulatorModal(false)} />}
        </div>
    )
}
